import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <------------------ Add Advert Component --------------------->
// ###############################################################
export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px);
`;

export const AddAdvertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - 131px);
  min-height: calc(100vh - 131px);
  padding: 24px 24px 51px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const FormWrapper = styled.div`
  width: 60%;
  padding: 30px 0;
  background-color: white;
  border-radius: 8px;
`;

export const FormTitle = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  padding: 0 25px;
  color: ${({ theme }) => theme.colors.black};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  gap: 20px;
  padding: 0 25px;
`;

export const FormFieldWrapper = styled.div`
  ${({ fullWidth }) =>
    fullWidth &&
    `
    grid-column: 1/3;
  `}
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const FormMultiFieldWrapper = styled.div`
  display: flex;

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const FormMultiFieldInputWrapper = styled.div`
  flex-basis: 0;
  flex-grow: ${({ flexRatio }) => flexRatio};
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
  ${({ centerText }) => centerText && 'text-align: center;'}
`;

export const FormBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormBtn = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <---------------- End Add Advert Component ------------------->
// ###############################################################

// ###############################################################
// <----------------- Search Products Envelop ------------------->
// ###############################################################
export const EnvelopItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey003};
    cursor: pointer;
  }

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const EnvelopItemImage = styled.img`
  width: 60px;
`;

export const EnvelopItemNameWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  & > * + * {
    margin-top: 6px !important;
  }
`;

export const EnvelopItemName = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const EnvelopItemType = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;

export const EnvelopItemPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 85px;

  & > * + * {
    margin-top: 2px !important;
  }
`;

export const EnvelopItemPrice = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;

export const EnvelopItemStock = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 4px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
`;

export const EnvelopLoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;

  ${({ fullHeight }) =>
    fullHeight &&
    `
    min-height: calc(100vh - 52px);`}
`;

export const NoDataText = styled.p`
  margin: 0;
  font-size: 15px;
  color: #9c9c9c;
`;

export const SelectedProduct = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  margin: 8px 8px 0 0;
  padding: 2px 8px;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.blueLight};
  border-radius: 6px;
`;

export const SelectedProductCloseIcon = styled.span`
  &:after {
    content: '\\e91f';
    font-family: icomoon;
    font-size: 10px;
    font-weight: 900;
    margin-inline-start: 10px !important;
    color: ${({ theme }) => theme.blueMain};
    cursor: pointer;
  }
`;
// ###############################################################
// <--------------- End Search Products Envelop ----------------->
// ###############################################################
